import { useTranslation } from "hooks/useTranslation";
import { DynamicLink } from "shared/components/DynamicLink";
import styles from "../DropdownContent.module.scss";

export const ProductsDropdownContent = ({ closeDropdown }) => {
  const { translate } = useTranslation();
  const productLinks = {
    1: [
      { name: translate("solder bath"), isDisabled: false },
      { name: translate("solder pumps"), isDisabled: false },
    ],
    2: [
      { name: translate("control"), isDisabled: true },
      { name: translate("monitoring"), isDisabled: true },
      { name: translate("inspection"), isDisabled: true },
    ],
    3: [
      { name: translate("handload"), highlighted: true },
      { name: translate("Jade MKII") },
      { name: translate("Jade Pro") },
      { name: translate("Jade Prodex") },
    ],
    4: [
      { name: translate("In - Line"), highlighted: true },
      { name: translate("Synchrodex Fluxer Module") },
      { name: translate("Synchrodex Pre-Heat Module") },
      { name: translate("Synchrodex Solder Module") },
      { name: translate("Synchrodex Pro 1060mm Fluxer Module") },
      { name: translate("Synchrodex Pro 1060mm Pre-Heater Module") },
      { name: translate("Synchrodex Pro 1060mm Solder Module") },
      { name: translate("Synchrodex Pro 1600 Pre-Heater Module") },
      { name: translate("Synchrodex Pro 1600 Single Bath Solder Module") },
      { name: translate("Synchrodex Pro 1600 Dual Bath Solder Module") },
      { name: translate("Fusion 4") },
      { name: translate("Fusion Pro 508") }, // TODO uncomment after adding new content
      // TEMPORARILY REMOVED
      // { name: translate("Orissa Fusion 3 Standard") },
      // { name: translate("Orissa Fusion 3 Compact") },
    ],
    5: [
      { name: translate("Coil Winding"), highlighted: true },
      { name: translate("Quadron") },
    ],
    6: [
      { name: translate("Other Equipment"), highlighted: true },
      { name: translate("Pillar GEN"), isDisabled: true },
      // { name: translate("Pillar Sonic"), isDisabled: true },
    ],
    7: [
      { name: translate("Machine Comparison"), highlighted: true },
      { name: translate("Handload Comparison"), isDisabled: true },
      { name: translate("In - Line Comparison"), isDisabled: true },
    ],
  };

  return (
    <div className={styles.container}>
      <div className={styles.column}>
        <div className={styles.titleBlock}>
          <h3 className={styles.title}>{translate("soldering")}</h3>
        </div>
        <div className={styles.contentBlock}>
          <div className={styles.column}>
            {productLinks[1].map((pl, idx) => (
              <DynamicLink
                isDisabled={pl.isDisabled}
                onClick={closeDropdown}
                key={idx}
                queryParams={{ name: pl.name }}
                to="/product"
                disables={pl.highlighted}
                className={`${styles.subTitle} ${
                  pl.highlighted && styles.highlighted
                } ${pl.isDisabled && styles.isDisabled}`}
              >
                {pl.name}
              </DynamicLink>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.column}>
        <div className={styles.titleBlock}>
          <h3 className={styles.title}>{translate("machines")}</h3>
        </div>
        <div className={styles.contentBlock}>
          <div className={styles.column}>
            {productLinks[3].map((pl, idx) => (
              <DynamicLink
                isDisabled={pl.isDisabled}
                onClick={closeDropdown}
                key={idx}
                queryParams={{ name: pl.name }}
                to="/product"
                disabled={pl.highlighted || pl.isDisabled}
                className={`${styles.subTitle} ${
                  pl.highlighted && styles.highlighted
                } ${pl.isDisabled && styles.isDisabled}`}
              >
                {pl.name}
              </DynamicLink>
            ))}
          </div>
          <div className={styles.column}>
            {productLinks[4].map((pl, idx) => (
              <DynamicLink
                isDisabled={pl.isDisabled}
                onClick={closeDropdown}
                key={idx}
                queryParams={{ name: pl.name }}
                to="/product"
                className={`${styles.subTitle} ${
                  pl.highlighted && styles.highlighted
                } ${pl.isDisabled && styles.isDisabled}`}
              >
                {pl.name}
              </DynamicLink>
            ))}
          </div>
          <div className={styles.column}>
            {productLinks[5].map((pl, idx) => (
              <DynamicLink
                isDisabled={pl.isDisabled}
                onClick={closeDropdown}
                key={idx}
                queryParams={{ name: pl.name }}
                to="/product"
                className={`${styles.subTitle} ${
                  pl.highlighted && styles.highlighted
                } ${pl.isDisabled && styles.isDisabled}`}
              >
                {pl.name}
              </DynamicLink>
            ))}
          </div>
          <div className={styles.column}>
            {productLinks[6].map((pl, idx) => (
              <DynamicLink
                isDisabled={pl.isDisabled}
                onClick={closeDropdown}
                key={idx}
                queryParams={{ name: pl.name }}
                to="/product"
                className={`${styles.subTitle} ${
                  pl.highlighted && styles.highlighted
                } ${pl.isDisabled && styles.isDisabled}`}
              >
                {pl.name}
              </DynamicLink>
            ))}
          </div>
          <div className={styles.column}>
            {productLinks[7].map((pl, idx) => (
              <DynamicLink
                isDisabled={pl.isDisabled}
                onClick={closeDropdown}
                key={idx}
                queryParams={{ name: pl.name }}
                to="/product"
                className={`${styles.subTitle} ${
                  pl.highlighted && styles.highlighted
                } ${pl.isDisabled && styles.isDisabled}`}
              >
                {pl.name}
              </DynamicLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
